import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';
import HttpMethodType from 'HttpMethodType';
class FinancialBlockESRequest extends BaseServiceRequest {
  constructor(requestObj) {
    super();
    super.addRequestUri("findgetblockses.pb");
    super.addRequestParameter("sym",requestObj.symbol);
    super.addRequestParameter("gtype",requestObj.periodicity);
    super.addRequestParameter("startdate",requestObj.startDate);

    if (requestObj.endDate !== null)
      super.addRequestParameter("enddate", requestObj.endDate);
    if (requestObj.selectCurrencyCode !== null && requestObj.selectCurrencyCode !== undefined) 
      super.addRequestParameter("scc", requestObj.selectCurrencyCode);
    if (requestObj.isMatchFinancials !== null && requestObj.isMatchFinancials !== undefined)
      super.addRequestParameter("ismf", requestObj.isMatchFinancials);
    super.addRequestParameter("iscf",requestObj.getFinancial);
    super.addRequestParameter("isown",requestObj.getOwnership);
    super.addRequestParameter("listid",requestObj.ownerListId);
    super.addRequestParameter("isflag",requestObj.isFlagged);
    super.addRequestParameter("iswon",requestObj.wonOnly);
    super.addRequestParameter("revwon",requestObj.revWonOnly);
    super.addRequestParameter("headers",requestObj.headers);
    super.addRequestParameter("productVersion", requestObj.ProductVersion);
    super.addRequestParameter("isFinancialES", 1);
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }

  getMessageName() {
    return "FinancialBlockDataResponse";
  }
}

export default FinancialBlockESRequest;